module.exports = __webpack_public_path__ + "img/icon_arrow-right_dark_orange.8712ed53.svg";